var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("div", { staticClass: "filter-serarch-container" }, [
        _c(
          "div",
          [
            _c(
              "vxe-button",
              {
                directives: [{ name: "waves", rawName: "v-waves" }],
                staticClass: "filter-search-item",
                attrs: {
                  loading: _vm.downloadLoading,
                  status: "primary",
                  icon: "el-icon-circle-plus-outline",
                },
                on: { click: _vm.handleAdd },
              },
              [_vm._v("新建")]
            ),
            _c(
              "vxe-button",
              {
                directives: [{ name: "waves", rawName: "v-waves" }],
                staticClass: "filter-search-item",
                attrs: {
                  loading: _vm.downloadLoading,
                  status: "danger",
                  icon: "el-icon-delete",
                },
                on: { click: _vm.handleDelete },
              },
              [_vm._v("删除")]
            ),
            _c(
              "vxe-button",
              {
                directives: [{ name: "waves", rawName: "v-waves" }],
                staticClass: "filter-search-item",
                attrs: {
                  loading: _vm.addLoading,
                  status: "success",
                  icon: "el-icon-refresh",
                },
                on: { click: _vm.refresh },
              },
              [_vm._v("刷新")]
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "search-box" },
          [
            _c(
              "div",
              { staticClass: "filter-search-item" },
              [
                _c("el-input", {
                  style: { width: "100%" },
                  attrs: { placeholder: "输入类型名称/编码", clearable: "" },
                  on: { change: _vm.handleFilter },
                  model: {
                    value: _vm.formData.nameOrAccount,
                    callback: function ($$v) {
                      _vm.$set(_vm.formData, "nameOrAccount", $$v)
                    },
                    expression: "formData.nameOrAccount",
                  },
                }),
              ],
              1
            ),
            _c(
              "vxe-button",
              {
                directives: [{ name: "waves", rawName: "v-waves" }],
                staticClass: "filter-search-item",
                staticStyle: { "margin-left": "10px" },
                attrs: { status: "primary", icon: "el-icon-search" },
                on: { click: _vm.handleFilter },
              },
              [_vm._v("查询")]
            ),
          ],
          1
        ),
      ]),
      _c(
        "vxe-table",
        {
          ref: "xTable2",
          staticClass: "mytable-scrollbar",
          staticStyle: { "margin-top": "5px", "margin-left": "6px" },
          attrs: {
            border: "",
            "show-header-overflow": "",
            "show-overflow": "",
            "column-config": { resizable: true },
            stripe: "",
            round: "",
            loading: _vm.listLoading,
            align: _vm.allAlign,
            "scroll-y": { enabled: false },
            "row-config": { isHover: true },
            data: _vm.tableDealerData,
          },
        },
        [
          _c("vxe-column", { attrs: { type: "checkbox", width: "60" } }),
          _c("vxe-column", {
            attrs: { type: "seq", title: "序号", width: "60", align: "center" },
          }),
          _c("vxe-column", {
            attrs: {
              visible: false,
              field: "id",
              title: "id",
              align: "center",
            },
          }),
          _c("vxe-column", {
            attrs: { field: "code", title: "类型编码", align: "center" },
          }),
          _c("vxe-column", {
            attrs: { field: "name", title: "类型名称", align: "center" },
          }),
          _c("vxe-column", {
            attrs: { field: "status", title: "状态", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    row.status === "1"
                      ? _c("span", [_vm._v("有效")])
                      : _c("span", [_vm._v("无效")]),
                  ]
                },
              },
            ]),
          }),
          _c("vxe-column", {
            attrs: { field: "remark", title: "备注", align: "center" },
          }),
          _c("vxe-column", {
            attrs: { field: "creator", title: "创建人", align: "center" },
          }),
          _c("vxe-column", {
            attrs: { title: "操作", align: "center", fixed: "right" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c(
                      "el-link",
                      {
                        attrs: { status: "primary", icon: "el-icon-edit" },
                        on: {
                          click: function ($event) {
                            return _vm.viewDetail(row)
                          },
                        },
                      },
                      [_vm._v("查看")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("vxe-pager", {
        attrs: {
          loading: _vm.listLoading,
          "current-page": _vm.tablePage.currentPage,
          "page-size": _vm.tablePage.pageSize,
          total: _vm.tablePage.totalResult,
          layouts: [
            "PrevPage",
            "JumpNumber",
            "NextPage",
            "FullJump",
            "Sizes",
            "Total",
          ],
        },
        on: { "page-change": _vm.handlePageChange },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }